import React, { useState } from 'react';
import { translate } from '../../Services/translation';
import { subcribeToBackInStock } from '../../Services/BackInStock.service';
import Icon from '../Icon';

interface BackInStockdModalProps {
  productId: string;
  size?: string;
  isModalOpen?: boolean;
  personalDataPagePointer?: string;
  onButtonClick: () => void;
}

const BackInStockdModal: React.FC<BackInStockdModalProps> = ({
  productId,
  size,
  personalDataPagePointer,
  isModalOpen,
  onButtonClick,
}) => {
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [email, setEmail] = useState('');

  const closeModal = () => {
    setIsSuccess(false);
    setError(false);
    setErrorMessage('');
    setEmail('');
    onButtonClick();
  };

  const handleChange = (event) => {
    setEmail(event.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await subcribeToBackInStock(productId, email);
      setError(false);
      setIsSuccess(true);
    } catch (err) {
      let res;
      let errorResponse;
      if (err.response) {
        try {
          res = await err.response.json();
        } catch (_) {}
      }

      setError(true);
      if (res) {
        errorResponse = res.message;
      }
      if (err.response.status == 409) {
        setErrorMessage(
          errorMessage || translate('out-of-stock.notify-me.conflict')
        );
      } else {
        setErrorMessage(
          errorMessage || translate('out-of-stock.notify-me.error')
        );
      }
    }
  };
  return (
    <div>
      {isModalOpen && (
        <div
          className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-20"
          onClick={closeModal}
        >
          <div
            className="bg-white text-center justify-center mx-auto px-10 py-8 absolute top-1/2 md:top-1/4 mt-6 md:mt-52 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 md:w-[400px] md:h-[353px] w-[328px] h-[377px]"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <a
              className="h-6 w-6 absolute top-3 right-3 text-grey-900 hover:cursor-pointer"
              onClick={closeModal}
            >
              <Icon name="close" className="w-6 h-6 text-grey-900" />
            </a>
            {!isSuccess ? (
              <div className="flex flex-col justify-start items-start text-start h-full py-0 px-0 my-0">
                <div className="flex text-2xl font-bold my-4">
                  {size !== '' ? (
                    <span>
                      {translate('out-of-stock.modal-storrelse')} {size}
                      &nbsp;{' '}
                    </span>
                  ) : (
                    <span>
                      {translate('out-of-stock.modal-produkten')}&nbsp;{' '}
                    </span>
                  )}
                  {translate('out-of-stock.modal-header')}
                </div>
                <p className="mb-4">
                  {translate('out-of-stock.modal-text')}
                </p>
                <div className="font-semibold mb-4">
                  {translate('out-of-stock.modal-mail')}
                </div>
                <form
                  onSubmit={(e) => handleSubmit(e)}
                  className="w-full flex flex-col gap-4"
                >
                  <input
                    type="text"
                    onChange={handleChange}
                    placeholder={translate('out-of-stock.modal-mail')}
                    className="w-full h-14 p-3 border border-grey"
                  />
                  <button
                    type="submit"
                    className="w-full h-12 bg-black text-base text-white p-3 font-bold mb-4"
                  >
                    {translate('out-of-stock.modal-sendbutton')}
                  </button>
                </form>
                <div className="mb-4">
                  {error && (
                    <div className="text-red-500">{errorMessage}</div>
                  )}
                </div>
                <div className="flex justify-center items-center h-full w-full mb-6">
                  <a
                    href={
                      personalDataPagePointer &&
                      personalDataPagePointer.href
                        ? personalDataPagePointer.href
                        : '#'
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                    className="underline text-base font-normal"
                  >
                    {translate('out-of-stock.modal-privacypolicy')}
                  </a>
                </div>
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center h-full">
                <Icon
                  name="hands"
                  aria-label={translate(
                    'out-of-stock.modal-successheader'
                  )}
                  className="h-12 w-12 text-grey-900"
                />
                <p className="text-2xl font-bold my-4">
                  {translate('out-of-stock.modal-successheader')}
                </p>
                <p>{translate('out-of-stock.modal-successmessage')}</p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default BackInStockdModal;
